import React from 'react';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './BenefitPlaceholder.scss';
var BenefitPlaceholder = function () { return (React.createElement(Flex, { alignItems: "flex-start" },
    React.createElement(CheckIcon, { className: s['icon'], size: IconSize.SMALLER, disableDefaultColors: true }),
    React.createElement("div", { className: s['lines'] },
        React.createElement("div", { className: s['line'] }),
        React.createElement("div", { className: s['line'] })))); };
BenefitPlaceholder.displayName = 'BenefitPlaceholder';
export default BenefitPlaceholder;
//# sourceMappingURL=BenefitPlaceholder.js.map